<template>
  <q-card flat bordered :dark="isDarkModeGlobal">
    <q-card-section
      :dark="isDarkModeGlobal"
      class="q-pt-none text-center"
      ref="docs_container"
      id="docs_container"
    >
      <canvas-timing-graph
        v-if="timingGraphAvailable"
        @loading="isLoading"
        :parent-width="width * .95"
      />
    </q-card-section>
  </q-card>
</template>

<script setup lang="ts">
import {
  ref,
  useTemplateRef
} from 'vue'
import CanvasTimingGraph from "./CanvasTimingGraph.vue"
import { storeToRefs } from "pinia"
import { useElementSize } from '@vueuse/core'
const calculatorStore = useCalculatorStore()
import { useCalculatorStore } from '../stores/calculator.store'

const {
  isDarkModeGlobal
} = storeToRefs(calculatorStore)
const loading = ref(false)
const timingGraphAvailable = ref(false)

function isLoading(val) {
  loading.value = val
}

if (typeof Worker !== "undefined") {
  timingGraphAvailable.value = true
}

const el = useTemplateRef('docs_container')

const { width } = useElementSize(el)
</script>

